// extracted by mini-css-extract-plugin
export default {"installation":"installationWindow_installation__RkRkE"};